module.exports = __webpack_public_path__ + "img/hit+.fc567429.png";